export default "__VITE_ASSET__b6f9cef4__"